import React from 'react';
import ServiceLandingPage from './ServiceLandingPage';
import { pageMeta, faq, sections, steps } from '../content/insolvencyContent';
import { insolvencySuccessStoryImages } from '../data/successStoriesImages';

const InsolvencyLawyerPage = () => (
  <ServiceLandingPage
    {...pageMeta}
    faq={faq}
    sections={sections}
    steps={steps}
    showSuccessStories
    successStoryImages={insolvencySuccessStoryImages}
    midPageCta="eligibility"
  />
);

export default InsolvencyLawyerPage;
